import * as React from "react";
import { isAbsoluteUrl } from "../../util/image";
import config from '../../config/urlConfig';
import LazyImage from "./ImageLazyLoad";


// import ReactProgressiveImage from "react-progressive-image";


export interface State { }

export default class AvatarImage extends React.Component<any, State> {
  private defaultSrc = "../../assets/img/no_image.jpg";

  constructor(props) {
    super(props);
    this.onError = this.onError.bind(this);
  }

  render() {
    return (
      <LazyImage {...this.props} src={this.imageUrl}/>
    );
  }

  get imageUrl() {
    let imageUrl = this.defaultSrc;

    if (this.props.src) {
      if (isAbsoluteUrl(this.props.src)) {
        imageUrl = this.props.src;
      } else if (this.props.usefileurl) {
        imageUrl = `${config.app.api_image}${this.props.src}`;
      } else {
        imageUrl = `${config.app.api_image}${this.props.src}`;
      }
    }

    return imageUrl;
  }

  private onError(e) {
    e.target.src = this.defaultSrc;
  }
}
